import { getMarket } from '../../modules/i18n';

/**
 * Implements the following market related features, that react to the user's current market:
 * * Whenever a link is initialized and has marketUris in its link data, it will check if there's a URL provided for the user's market.
 *   If yes, then the href attribute value will be replaced with the uri for the market.
 */
const marketContentModification = {
  currentMarket: null,
  scope: null,
  init(scope) {
    this.scope = scope || document;
  },
  bindEarlyEvents() {
    getMarket().then((market) => { this.currentMarket = market; });
    document.body.addEventListener('jb-link:initialized', (event) => {
      if (!event.detail.marketUris) {
        return;
      }

      event.stopPropagation();
      const userMarket = parseInt(this.currentMarket, 10);
      if (userMarket === 0) {
        return;
      }
      const matchingEntry = event.detail.marketUris.find((entry) => entry.marketUid === userMarket);
      if (!matchingEntry) {
        return;
      }
      event.detail.linkTag.setAttribute('href', matchingEntry.href);
      if (event.detail.linkableComponent) {
        const { linkableComponent } = event.detail;
        linkableComponent.link.href = event.detail.marketUris[this.currentMarket];
      }
    });
  },
};

export default marketContentModification;
